import React from 'react';

const Loader = () => {
    return (<center>Loading...</center>);
}
 
export default Loader;